import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import {MessageService} from 'primeng/api';
import { CommonService } from 'src/app/services/common.service';
import { Router } from '@angular/router';



@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.scss']
})
export class VerifyEmailComponent implements OnInit {

  constructor(public auth:AuthService,private messageService: MessageService,public common:CommonService,public router:Router) { }

  ngOnInit(): void {
    if(this.auth.user.email_verified_at){
      this.router.navigateByUrl("/account")
    }
  }

  resendVerifyLink(){
    this.common.showLoader()
    this.auth.resendverify().subscribe(res=>{
      this.common.stopLoader()
      //console.log(res)
      this.messageService.add({severity:'success', summary:'Successful', detail:"Please check your email again for verification link."});
    },err=>{
      let errorKeys = Object.keys(err.error.errors); 
      errorKeys.forEach(key => { 
        //console.log(key)
        let value = err.error.errors[key][0]; 
        this.messageService.add({severity:'error', summary:value, detail:""});
        //console.log(value); 
    }); 
      //console.log(err)
      this.common.stopLoader()
    })
  }

}
